import store from '@/store';

export const authorize = (to, from, next) => {
  const authorized =
    to.meta.publicRoute || localStorage.getItem('access_token');
  if (authorized) {
    return next();
  } else {
    store.dispatch('user/clearStateData');
    return next({
      name: 'login',
    });
  }
};
